import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./HandEyeResult.css";

const HandEyeResult = () => {
  const navigate = useNavigate();

  const [leaderboard, setLeaderboard] = useState([]);
  const [userRank, setUserRank] = useState(null);
  const [currentBreakdown, setCurrentBreakdown] = useState(null);
  const [currentTotal, setCurrentTotal] = useState(null);
  const [currentPercentile, setCurrentPercentile] = useState(null);

  // ================= FETCH =================
  const fetchLeaderboard = async () => {
    try {
      const email = localStorage.getItem("user_email");

      const res = await axios.get(`/handeyeleaderboard?email=${email}`);

      setLeaderboard(res.data.leaderboard || []);
      setUserRank(res.data.userRank || null);
      setCurrentBreakdown(res.data.currentBreakdown || null);

      // ✅ NEW FROM BACKEND
      setCurrentTotal(res.data.currentTotal ?? null);
      setCurrentPercentile(res.data.currentPercentile ?? null);

    } catch (e) {
      console.log("Leaderboard Error:", e);
    }
  };

  useEffect(() => {
    fetchLeaderboard();
  }, []);

  return (
    <div className="result-big-container">

      {/* ================= LEADERBOARD ================= */}
      <div className="leaderboard-box">
        <h3>Leaderboard</h3>

        <table>
          <thead>
            <tr>
              <th>Rank</th>
              <th>Name</th>
              <th>Score</th>
              <th>Medal</th>
            </tr>
          </thead>

          <tbody>
            {leaderboard.length > 0 ? (
              leaderboard.map((p, i) => (
                <tr key={i}>
                  <td>{p.rank}</td>
                  <td>{p.name}</td>
                  <td>{p.score}s</td>
                  <td>{["🥇", "🥈", "🥉"][i] || ""}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No data</td>
              </tr>
            )}
          </tbody>
        </table>

        {/* USER STATS */}
        {userRank && (
          <div className="your-rank-box">
            <p><b>🏅 Rank:</b> {userRank.rank}</p>

            <p>
              <b>⚡Score:</b>{" "}
              {currentTotal != null ? `${currentTotal}s` : "--"}
            </p>

            <p>
              <b>📊 Percentile:</b>{" "}
              {currentPercentile != null ? `${currentPercentile}%` : "--"}
            </p>
          </div>
        )}
      </div>

      {/* ================= RESULT ================= */}
      <div className="results-box">
        <h2>Your Result</h2>

        {userRank ? (
          <>
            <p>
              <b>⏱ Current:</b>{" "}
              {currentTotal != null ? `${currentTotal}s` : "--"}
            </p>

            

            {/* BREAKDOWN */}
            {/* BREAKDOWN */}
            <div className="breakdown-box">
              <h4>⏱ Breakdown:</h4>

              <p>⬜ Square: {currentBreakdown?.square != null ? `${Number(currentBreakdown.square).toFixed(2)}s` : "—"}</p>
              <p>📏 Line: {currentBreakdown?.line != null ? `${Number(currentBreakdown.line).toFixed(2)}s` : "—"}</p>
              <p>⭕ Circle: {currentBreakdown?.circle != null ? `${Number(currentBreakdown.circle).toFixed(2)}s` : "—"}</p>
              <p>🌊 Curve: {currentBreakdown?.curve != null ? `${Number(currentBreakdown.curve).toFixed(2)}s` : "—"}</p>
            </div>

           
            <p>Lower time = better performance 🎯</p>
          </>
        ) : (
          <p>Loading...</p>
        )}

        {/* BUTTONS */}
        <button onClick={() => navigate("/hand-eye/square")}>
          Try Again
        </button>

        <button onClick={() => navigate("/hand-eye")}>
          Exit
        </button>
      </div>

    </div>
  );
};

export default HandEyeResult;